import moment from "moment";

export const getJobIdFromItem = (item = {}) =>
  item?.jobPostId ||
  item?.JobPostId ||
  item?.jobId ||
  item?.JobId ||
  item?.id ||
  item?.Id ||
  0;

export const getJobIsExternal = (item = {}) => Boolean(item?.isExternal ?? item?.IsExternal ?? false);

export const getJobFavoriteKey = (item) => {
  const jobId = getJobIdFromItem(item);
  if (!jobId) return null;
  return `${getJobIsExternal(item) ? "external" : "internal"}-${jobId}`;
};

export const getExpiryLabel = (expiryDate) => {
  if (!expiryDate) return null;
  const expiry = moment(expiryDate);
  if (!expiry.isValid()) return null;
  const daysLeft = expiry.diff(moment(), "days");
  if (daysLeft < 0 || daysLeft > 5) return null;
  if (daysLeft === 0) return "Expires today";
  if (daysLeft === 1) return "Expires in a day";
  return `Expires in ${daysLeft} days`;
};
